module.exports = __webpack_public_path__ + "media/images/samples/home/news/n2-59c62dab22df3b7b5b09f3ab76b152ea.png";